import boxLoading from "asset/lottie/box_loading.json";
import boxLoading2 from "asset/lottie/box_loading_1.json";
import Lottie from 'react-lottie';
import './ReavealLottieModal.css'
import {useEffect} from "react";
const RevealLottieModal = (props) => {
    // 열기, 닫기, 모달 헤더 텍스트를 부모로부터 받아옴
    const { open } = props;

    const defaultOptions = { //예제1
        loop: true,
        autoplay: true,
        animationData: boxLoading,
        //animationData: boxLoading2,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
            className: 'lottie-img',
        },
    };

    return (
        <>
            <div className={"bg-black reveal-lottie-wrap " + open}>
                <Lottie
                    options={defaultOptions}
                    isClickToPauseDisabled={true}
                />
            </div>
        </>
    );
}

export default RevealLottieModal;